<div class="form_container dialog_form no_padding_bottom">
  <p>{{ confirmationMessage | translate }}</p>
  <div class="dialog_form_buttons">
      <button (click)="onResponse(true)" class="submit_btn">{{ 'siren-admin-translation.confirmation_dialog.yes' | translate }}</button>
      <button (click)="onResponse(false)" mat-button class="action_btn">{{ 'siren-admin-translation.confirmation_dialog.no' | translate }}</button>
  </div>
</div>
